import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEdit2, FiTrash2, FiExternalLink, FiShoppingBag } = FiIcons;

const CATEGORY_COLORS = {
  apparel:     'text-purple-400 bg-purple-500/10 border-purple-500/20',
  vinyl:       'text-amber-400 bg-amber-500/10 border-amber-500/20',
  digital:     'text-blue-400 bg-blue-500/10 border-blue-500/20',
  accessories: 'text-pink-400 bg-pink-500/10 border-pink-500/20',
  bundle:      'text-green-400 bg-green-500/10 border-green-500/20',
  other:       'text-zinc-400 bg-zinc-800 border-zinc-700',
};

const MerchCard = ({ item, onEdit, onDelete }) => {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const colorCls = CATEGORY_COLORS[item.category] || CATEGORY_COLORS.other;

  return (
    <div className={`rounded-2xl border overflow-hidden transition-all ${item.is_active ? 'border-zinc-700 bg-zinc-900/60' : 'border-zinc-800/40 bg-zinc-900/20 opacity-60'}`}>
      {/* Image */}
      <div className="relative h-40 bg-zinc-900 flex items-center justify-center overflow-hidden">
        {item.image_url ? (
          <img src={item.image_url} alt={item.title} className="w-full h-full object-cover" />
        ) : (
          <SafeIcon icon={FiShoppingBag} className="text-4xl text-zinc-800" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <span className={`absolute top-3 left-3 px-3 py-1 rounded-full border text-[10px] font-black uppercase tracking-widest ${colorCls}`}>
          {item.category}
        </span>
        {!item.is_active && (
          <span className="absolute top-3 right-3 px-3 py-1 rounded-full border border-zinc-700 bg-zinc-800 text-zinc-500 text-[10px] font-black uppercase tracking-widest">
            Hidden
          </span>
        )}
      </div>

      <div className="p-5 space-y-4">
        <div>
          <h4 className="font-black text-white uppercase tracking-tight leading-tight">{item.title}</h4>
          {item.description && <p className="text-xs font-bold text-zinc-500 mt-1 line-clamp-2">{item.description}</p>}
        </div>

        <div className="flex items-center justify-between">
          <span className="text-2xl font-black text-white">${(item.price || 0).toFixed(2)}</span>
          {item.buy_url && (
            <a href={item.buy_url} target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-1.5 px-3 py-1.5 bg-zinc-800 border border-zinc-700 rounded-xl text-[10px] font-black uppercase tracking-widest text-zinc-400 hover:text-white transition-all">
              <SafeIcon icon={FiExternalLink} className="text-xs" /> Store
            </a>
          )}
        </div>

        {confirmDelete ? (
          <div className="flex items-center gap-2">
            <p className="text-xs font-black text-red-400 flex-1">Delete?</p>
            <button onClick={() => { onDelete(item.id); setConfirmDelete(false); }}
              className="px-3 py-2 bg-red-500/20 border border-red-500/40 text-red-400 text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-red-500/30 transition-all">Yes</button>
            <button onClick={() => setConfirmDelete(false)}
              className="px-3 py-2 border border-zinc-700 text-zinc-400 text-[10px] font-black uppercase tracking-widest rounded-xl">No</button>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <button onClick={() => onEdit(item)}
              className="flex-1 flex items-center justify-center gap-1.5 py-2.5 border border-zinc-700 rounded-xl text-[10px] font-black uppercase tracking-widest text-zinc-400 hover:border-zinc-500 hover:text-white transition-all">
              <SafeIcon icon={FiEdit2} className="text-xs" /> Edit
            </button>
            <button onClick={() => setConfirmDelete(true)}
              className="p-2.5 rounded-xl border border-zinc-800 text-zinc-500 hover:text-red-400 hover:border-red-500/40 transition-all">
              <SafeIcon icon={FiTrash2} className="text-sm" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MerchCard;